import React from 'react';
import { Card, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import "./index.css";

const CardHome = ({ title, icon, links = [] }) => {
    const navigate = useNavigate();

    return (
        <Card className="card-home h-100">
            <Card.Header className="text-center d-flex flex-column align-items-center justify-content-center">
                <i className={`fa ${icon} fa-4x mb-2`} aria-hidden="true"></i>
                <h5 className="mb-0">{title}</h5>
            </Card.Header>
            <Card.Body className="p-0">
                <ListGroup variant="flush">
                    {links.map((link, index) => {
                        // Verifica se o link é para uma URL externa
                        const isExternal = typeof link.to === "string" && (link.to.startsWith("http://") || link.to.startsWith("https://"));

                        // Se for um link externo, usa a tag <a>
                        if (isExternal) {
                            return (
                                <ListGroupItem key={index} className="p-0">
                                    <a
                                        href={link.to}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`card-link ${link.className || ""}`}
                                    >
                                        {link.icon && <i className={`fa ${link.icon} mr-3`} aria-hidden="true"></i>}
                                        <span>{link.text}</span>
                                    </a>
                                </ListGroupItem>
                            );
                        }

                        // Se for um link interno, usa o componente <Link> do React Router
                        return (
                            <ListGroupItem key={index} className="p-0">
                                <Link
                                    to={link.to}
                                    className={`card-link ${link.className || ""}`}
                                >
                                    {link.icon && <i className={`fa ${link.icon} mr-3`} aria-hidden="true"></i>}
                                    <span>{link.text}</span>
                                </Link>
                            </ListGroupItem>
                        );
                    })}
                </ListGroup>
            </Card.Body>
        </Card>
    );
};

export default CardHome;